import NoMatchFoundIcon from "assets/icons/NoMatchFoundIcon";
import React from "react";
import styles from "./style.module.scss";

export default function EmptyState() {
  return (
    <div className={styles.noMatchFound}>
      <div data-testid="no-match-icon">
        <NoMatchFoundIcon />
      </div>
      <span>
        No matches found
        <br />
        please try another term
      </span>
    </div>
  );
}
